import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import { getGameBackground } from '../scenes/GameBackground';
import SoundAssetKeys from '../SoundAssetKeys';
import CupStackGameLevel from './CupStackGameLevel';

export default class CupStackGame extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     * @param {number} x 
     * @param {number} y 
     */
    constructor(scene, x, y)
    {
        super(scene, x, y);

        this.curLevelIndex = 1;
        this.curLevel = null;
    }

    startGame()
    {
        this.startLevel();
    }

    startLevel()
    {
        //stop background
        getGameBackground().pan("stop");
        //create level
        this.curLevel = new CupStackGameLevel(this.scene);
        this.add(this.curLevel);
        this.curLevel.once("LEVEL_READY", this.handleLevelReady, this);
        this.curLevel.once("LEVEL_COMPLETE", this.handleLevelComplete, this);
        this.scene.time.delayedCall(500, this.curLevel.createAllStacks, null, this.curLevel);
    }

    handleLevelReady()
    {
        let event = { _showFlag: true }
        this.emit("CONTROL_KEYS", event);

        this.emit("START_LEVEL");
    }

    handleLevelComplete()
    {
        this.curLevel.destroy();
        this.curLevel = null;
        this.curLevelIndex++;

        if (this.curLevelIndex < 5)
        {
            this.emit("END_LEVEL");
            ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._basket_menu_tween, this.scene);
            this.scene.time.delayedCall(1300, this.startLevel, null, this);
        }
        else
        {
            this.emit("GAME_COMPLETE");
        }
    }

    keyInput(val)
    {
        if (this.curLevel) this.curLevel.stackCup(val);
    }
}